module.exports = __webpack_public_path__ + "assets/img/tech-12.af8ad5fe.svg";